import { useTranslation } from 'react-i18next';
import { FilterDefinitionModel } from 'src/core/model/data-grid.model';
import { useDateRangeFilter } from 'src/feature/data-grid/filter/generic-filter/use-date-range-filter';
import { useNumberRangeFilter } from 'src/feature/data-grid/filter/generic-filter/use-number-range-filter';
import { InvoiceModel } from '@delmonicos/shared-sdk/libs/emsp/src/libs/invoices-service-lib/src/wrapper/outputs/invoice.model';

export function useInvoiceFilter(): FilterDefinitionModel[] {
  const { t } = useTranslation();

  const invoiceTranslations: Record<keyof InvoiceModel, string> = t(
    'model.invoice-v2',
    {
      returnObjects: true,
    },
  );

  const amountFilter = useNumberRangeFilter({
    label: invoiceTranslations.totalTTC,
    keyMin: 'totalTTCMin',
    keyMax: 'totalTTCMax',
    valueFormatter: (value) => t('data-grid.row.currency', { value }),
  });

  const updatedAtFilter = useDateRangeFilter({
    label: invoiceTranslations.updatedAt,
    keyMin: 'updatedAfter',
    keyMax: 'updatedBefore',
  });

  const createdAtFilter = useDateRangeFilter({
    label: invoiceTranslations.createdAt,
    keyMin: 'createdAfter',
    keyMax: 'createdBefore',
  });

  return [amountFilter, updatedAtFilter, createdAtFilter];
}
